module.exports = __webpack_public_path__ + "static/media/320x100_0010_ro.63625e73.png";